import OktaAuth from '@okta/okta-auth-js';

import ooeConstants from './constants';

const authClient = new OktaAuth({
  ...ooeConstants.OKTA_CONFIG,
  scopes: ['openid', 'email', 'offline_access'],
  tokenManager: {
    autoRenew: true,
    storageKey: ooeConstants.OKTA_STORAGE_KEY,
  },
  services: {
    autoRenew: false,
    autoRemove: false,
  },
  transformAuthState: async (oktaAuth, authState) => {
    if (!authState.isAuthenticated) {
      return authState;
    }
    const user = await oktaAuth.token.getUserInfo();
    authState.isAuthenticated = !!user.cfa_aud;
    authState.user = user;
    return authState;
  },
});

export default authClient;
